export const DEFAULT_MESSAGE = 'This node was a duplicate and logic has been merged.';
export const SNIPPET_UPGRADE_MESSAGE = "This node's logic was updated with the latest snippet changes.";
